import { Card, Stack, Tabs } from '@mantine/core';
import { ProfileUser } from '../ProfileUser';
import { AccountTabList } from './AccountTabList';
import classes from './AccountTabList.module.css';
import { AccountInfoTab } from './Info';
import { AccountPreferenceTab } from './Preferences';
import { AccountSecurityTab } from './Security';
export const Account: React.FC = () => {
  return <Tabs.Panel value="account">
      <ProfileUser />
      <Card radius={5} mt={20} py={{
      base: 16,
      sm: 20,
      lg: 24
    }} px={{
      base: 10,
      sm: 20
    }} bg="var(--bg-200)" style={{
      overflow: 'visible'
    }}>
        <Tabs variant="pills" defaultValue="info" classNames={classes}>
          <Stack>
            <AccountTabList />
            <AccountInfoTab />
            <AccountSecurityTab />
            <AccountPreferenceTab />
          </Stack>
        </Tabs>
      </Card>
    </Tabs.Panel>;
};